import { Form, Formik } from 'formik'
import React from 'react'
import { required } from '../utils/validators'
import Button from './common/Button'
import Input from './common/Input'

export default function MessageForm({ initialValues, onSubmit, loading, onCancel }) {
    return (
        <Formik initialValues={{ text: '', ...initialValues }} onSubmit={onSubmit}>
            <Form>
                <Input
                    component="textarea"
                    label="Сообщение"
                    name="text"
                    disabled={loading}
                    placeholder="Введите ваше сообщение"
                    validate={required} />

                <Button
                    loading={loading}
                    text="Сохранить"
                    type="submit"
                    icon="ion-md-checkmark"
                    className="is-success" /> &nbsp;

                <Button
                    onClick={onCancel}
                    icon="ion-md-close"
                    text="Отмена"
                    className="is-danger" />
            </Form>
        </Formik>
    )
}
